"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = require("angular");
var project_category_assignment_logic_1 = require("./project-category-assignment.logic");
var filter_logic_1 = require("../../navigation/report-options2/filter-logic");
var tree_filter_1 = require("../../navigation/tree/app/js/logic/tree-filter");
var rich_text_box_1 = require("../input-screen/comment-box/rich-text-box/rich-text-box");
require('./project-category-assignment.component.css');
var ProjectCategoryAssignmentComponent = /** @class */ (function () {
    function ProjectCategoryAssignmentComponent($rootScope, $scope, $timeout) {
        // This constructor is necessary for inject scope and timeout.
        var ctrl = this;
        ctrl.$rootScope = $rootScope;
        ctrl.$scope = $scope;
        ctrl.$timeout = $timeout;
        ctrl.showAlert = function (type, title, message) {
            $scope.$emit('workbench:alert', { type: type, title: title, message: message });
        };
        $scope.$on('command:ProjectCategoryAssignment', function (event, args) {
            ctrl.$timeout(function () { return ctrl.initComponent(event, args); });
        });
    }
    ProjectCategoryAssignmentComponent.prototype.initComponent = function (event, args) {
        var ctrl = this;
        ctrl.$timeout(function () {
            ctrl.actionMenuItem = args.actionMenuItem;
            ctrl.nodeId = args.nodeId;
            ctrl.menuId = 'CateAssignPage';
            ctrl.currentNode = args.node;
            ctrl.username = args.username;
            ctrl.readOnly = args.node.permissions === "r";
            ctrl.isDirty = false;
            ctrl.showCommentCol = false;
            ctrl.nonPropagateCateSet = new Set(args.categoriesConfig.filter(function (cate) { return (cate.AutoPropagateUp === "false"); }).map(function (cate) { return cate.CategoryName; }));
            ctrl.generateCategoriesData(args.categoriesConfig, args.siblingNodeTags, args.node.role);
            ctrl.menu = ctrl.returnMenu();
            ctrl.treeViewFilter = args.treeViewFilter;
        });
    };
    ProjectCategoryAssignmentComponent.prototype.generateCategoriesData = function (categoriesConfig, siblingTags, userRole) {
        return __awaiter(this, void 0, void 0, function () {
            var ctrl, tags, categoryLog, categoryMap, categoryLogMap;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ctrl = this;
                        return [4 /*yield*/, ctrl.smartorg.tagsFor(ctrl.nodeId)];
                    case 1:
                        tags = _a.sent();
                        ctrl.currentTags = tags;
                        return [4 /*yield*/, ctrl.smartorg.categoryLogFor(ctrl.nodeId)];
                    case 2:
                        categoryLog = _a.sent();
                        categoryMap = project_category_assignment_logic_1.generateTagsMap(tags);
                        ctrl.siblingCategoryMap = siblingTags ? project_category_assignment_logic_1.generateTagsMap(siblingTags) : undefined;
                        categoryLogMap = categoryLog ?
                            categoryLog.reduce(function (map, cateLog) {
                                map[cateLog.Key] = cateLog.Comment;
                                return map;
                            }, {}) : {};
                        ctrl.categoriesData = categoriesConfig.filter(function (_a) {
                            var IsMultiSelect = _a.IsMultiSelect, ShowOnCategory = _a.ShowOnCategory;
                            return (IsMultiSelect === "false" && (ShowOnCategory === true || ShowOnCategory === 'true'));
                        }).map(function (_a) {
                            var CategoryName = _a.CategoryName, CategoryEntries = _a.CategoryEntries, AdminEditing = _a.AdminEditing, ContributorEditing = _a.ContributorEditing;
                            var selectedEntry = CategoryName in categoryMap ? categoryMap[CategoryName] : '';
                            var allowEdit = (AdminEditing == undefined || AdminEditing == true) &&
                                (userRole === 'a' ? true : userRole == 'c' ? ContributorEditing || false : false);
                            var historyData = CategoryName in categoryLogMap ? categoryLogMap[CategoryName] : [];
                            var lastCommentItem = (historyData && historyData.length) ? historyData[historyData.length - 1] : null;
                            var msgVal = lastCommentItem ? decodeURIComponent(lastCommentItem.msg) : '';
                            var universalTableComment = (lastCommentItem && lastCommentItem.universalTableComment) ?
                                '(' + lastCommentItem.universalTableComment + ') ' : '';
                            var comment = new rich_text_box_1.RichTextBox(msgVal);
                            var commentStr = project_category_assignment_logic_1.trimComment(universalTableComment + comment.toCommentStr());
                            return { CategoryName: CategoryName, CategoryEntries: CategoryEntries, selectedEntry: selectedEntry, allowEdit: allowEdit,
                                historyData: historyData, comment: comment, commentStr: commentStr, universalTableComment: universalTableComment };
                        });
                        ctrl.copyToOrig();
                        ctrl.$scope.$apply();
                        return [2 /*return*/];
                }
            });
        });
    };
    ProjectCategoryAssignmentComponent.prototype.copyToOrig = function () {
        this.origCategoriesData = angular.copy(this.categoriesData);
    };
    ProjectCategoryAssignmentComponent.prototype.updateCommentStr = function (category) {
        category.commentStr = project_category_assignment_logic_1.trimComment(category.universalTableComment + category.comment.toCommentStr());
    };
    ProjectCategoryAssignmentComponent.prototype.categoryFocus = function (category) {
        this.selectedCategory = category;
    };
    /**
     * History Modal
     */
    ProjectCategoryAssignmentComponent.prototype.showHistoryModal = function (category, index) {
        var ctrl = this;
        ctrl.categoryFocus(category);
        if (!category.historyData || category.historyData.length === 0) {
            ctrl.historyModalData = [];
            return;
        }
        var historyComments = category.historyData.slice(0).reverse(); // slice(0) makes a copy of original array
        var currentVal = ctrl.origCategoriesData[index].selectedEntry;
        ctrl.historyModalData = project_category_assignment_logic_1.formatHistoryModalData(historyComments, currentVal);
        setTimeout(function () {
            ctrl.$scope.$apply();
        }, 0);
    };
    ProjectCategoryAssignmentComponent.prototype.handleSeeMore = function (index) {
        this.historyModalData[index].seeMore =
            !this.historyModalData[index].seeMore;
    };
    /**
     * save methods
     */
    ProjectCategoryAssignmentComponent.prototype.checkSave = function () {
        // check if entry value and comment for each category are changed
        var ctrl = this;
        var isDirty = false;
        for (var i in ctrl.categoriesData) {
            var cateData = ctrl.categoriesData[i];
            var origCateData = ctrl.origCategoriesData[i];
            if (cateData.selectedEntry != origCateData.selectedEntry ||
                !angular.equals(cateData.comment, origCateData.comment)) {
                isDirty = true;
                break;
            }
        }
        ctrl.isDirty = isDirty;
        ctrl.setGlobalDirty();
    };
    ProjectCategoryAssignmentComponent.prototype.setGlobalDirty = function () {
        this.$rootScope.smartorgDirty = this.isDirty;
        this.$timeout();
    };
    ProjectCategoryAssignmentComponent.prototype.saveCategoryAssignment = function () {
        var ctrl = this;
        ctrl.$timeout(function () {
            var nodeTagList = project_category_assignment_logic_1.generateTagsData(ctrl.currentNode, ctrl.currentTags, ctrl.categoriesData, ctrl.nonPropagateCateSet);
            var categoryLogData = project_category_assignment_logic_1.generateLogData(ctrl.categoriesData, ctrl.origCategoriesData, ctrl.username);
            var changedCateSet = [];
            for (var i = 0; i < ctrl.categoriesData.length; i++) {
                if (ctrl.categoriesData[i].selectedEntry === ctrl.origCategoriesData[i].selectedEntry)
                    continue;
                changedCateSet.push(ctrl.categoriesData[i].CategoryName);
            }
            var needRefresh = false;
            // Page refresh needed if any category in tree-view-filter changed
            if (ctrl.treeViewFilter) {
                var filterLogic = filter_logic_1.createFilterLogic(ctrl.treeViewFilter);
                var filterList = tree_filter_1.parseSimpleFilterFromString(filterLogic) || [];
                filterList.forEach(function (filter) {
                    console.log(changedCateSet.indexOf(filter.name));
                    if (changedCateSet.indexOf(filter.name) >= 0)
                        needRefresh = true;
                });
            }
            ctrl.smartorg.saveTagsData(ctrl.nodeId, nodeTagList, categoryLogData, ctrl.menuId).then(function (res) {
                if (res.status === 1) {
                    ctrl.showAlert('danger', 'Error!', res.message);
                }
                else {
                    ctrl.saving = false;
                    ctrl.showAlert('success', 'Saved!', '');
                    if (needRefresh) {
                        ctrl.$scope.$emit('workbench:back', { reload: true });
                    }
                    ctrl.isDirty = false;
                    ctrl.updateCategoriesDataAfterSave(categoryLogData);
                    ctrl.copyToOrig();
                    ctrl.$scope.$emit('workbench:modifyNodeMap', nodeTagList);
                    ctrl.setGlobalDirty();
                    ctrl.$scope.$emit('workbench:last_updated', { nodeID: ctrl.nodeId });
                    ctrl.$timeout();
                }
            })["catch"](function (err) {
                ctrl.$timeout();
                ctrl.saving = false;
                ctrl.showAlert('danger', 'Error!', err.message);
            });
        });
    };
    ProjectCategoryAssignmentComponent.prototype.updateCategoriesDataAfterSave = function (categoryLogData) {
        var _this = this;
        this.categoriesData.forEach(function (cate) {
            if (cate.CategoryName in categoryLogData) {
                cate.historyData.push(categoryLogData[cate.CategoryName]);
                cate.universalTableComment = '';
                _this.updateCommentStr(cate);
            }
        });
    };
    /**
     * menu
     */
    ProjectCategoryAssignmentComponent.prototype.returnMenu = function () {
        var ctrl = this;
        return [{
                'name': 'Save',
                'class': 'btn btn-xs btn-danger',
                'show': function () {
                    return !ctrl.readOnly && ctrl.isDirty && !ctrl.saving;
                },
                'callback': function () {
                    ctrl.save();
                }
            }, {
                'name': 'Reset',
                'class': 'btn btn-xs btn-primary',
                'show': function () {
                    return ctrl.isDirty && !ctrl.saving;
                },
                'callback': function () {
                    ctrl.reset();
                }
            }, {
                'name': '',
                'class': 'btn btn-xs btn-danger',
                'icon': 'fa fa-spinner fa-spin fa-fw',
                'show': function () {
                    return ctrl.saving;
                }
            }, {
                'name': 'Display',
                'items': [{
                        'name': ctrl.showCommentCol ? 'Hide Comments and History' : 'Show Comments and History',
                        'toggle': ctrl.showCommentCol ? 'Show Comments and History' : 'Hide Comments and History',
                        'callback': function () {
                            ctrl.showCommentCol = !ctrl.showCommentCol;
                        }
                    }]
            }];
    };
    ProjectCategoryAssignmentComponent.prototype.save = function () {
        var ctrl = this;
        ctrl.saving = true;
        try {
            ctrl.saveCategoryAssignment();
        }
        catch (ex) {
            alert(ex.message);
        }
    };
    ;
    ProjectCategoryAssignmentComponent.prototype.reset = function () {
        var ctrl = this;
        ctrl.isDirty = false;
        ctrl.categoriesData = angular.copy(ctrl.origCategoriesData);
        ctrl.setGlobalDirty();
    };
    ;
    return ProjectCategoryAssignmentComponent;
}());
angular.module('smartorg.r6.acts.projectCategoryAssignment', []).component('projectCategoryAssignment', {
    template: require('./project-category-assignment.component.html'),
    controller: ProjectCategoryAssignmentComponent,
    bindings: {
        smartorg: '=',
        menu: '='
    }
});
module.exports = 'smartorg.r6.acts.projectCategoryAssignment';
//# sourceMappingURL=project-category-assignment.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/project-category-assignment/project-category-assignment.component.js